import { render } from "./App.vue?vue&type=template&id=4d980f03&bindings={\"autodetectLanguage\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script